// Generated by scripts/mdi/import-questionnaires.mjs from MDI "KPV 09.17.26" (76a24250-0a47-4c40-bdb3-9cdc68db45e1). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiKPVAnswerField } from './questions';

export const mdiKPV: FormType<mdiKPVAnswerField> = {
  name: 'KPV',
  validityLength: 25,
  questions: [
    {
      key: 'mdiKPV_sex',
      next: {
        switch: [
          { condition: { 'mdiKPV_sex.female': true }, key: 'mdiKPV_pregnancy' },
          {
            condition: { 'mdiKPV_pregnancy.yes': true },
            key: 'mdiKPV_wereSorryBasedPreviousAnswer'
          }
        ],
        els: 'mdiKPV_importantClickAttachedLinkReview'
      }
    },
    {
      key: 'mdiKPV_pregnancy',
      next: {
        condition: { 'mdiKPV_pregnancy.yes': true },
        key: 'mdiKPV_wereSorryBasedPreviousAnswer',
        els: 'mdiKPV_importantClickAttachedLinkReview'
      }
    },
    'mdiKPV_wereSorryBasedPreviousAnswer',
    'mdiKPV_importantClickAttachedLinkReview',
    'mdiKPV_reasonInterestedPeptide',
    {
      key: 'mdiKPV_everUsedPeptideTherapiesPast',
      next: {
        condition: { 'mdiKPV_everUsedPeptideTherapiesPast.yes': true },
        key: 'mdiKPV_peptidesUsedPreviously',
        els: 'mdiKPV_everReactionSideEffectsPeptide'
      }
    },
    'mdiKPV_peptidesUsedPreviously',
    {
      key: 'mdiKPV_everReactionSideEffectsPeptide',
      next: {
        condition: { 'mdiKPV_everReactionSideEffectsPeptide.yes': true },
        key: 'mdiKPV_reactionSideEffect',
        els: 'mdiKPV_diagnosedRedFlagMedicalConditions'
      }
    },
    'mdiKPV_reactionSideEffect',
    'mdiKPV_diagnosedRedFlagMedicalConditions',
    'mdiKPV_confirmNotHistoryCancerKidney',
    'mdiKPV_takeRedFlagMedicationsSubstances',
    'mdiKPV_allergyBenzylPeroxide',
    'mdiKPV_lastTimePersonMedicalEvaluation',
    'mdiKPV_confirmUnderstandContactDoctorQuestions',
    'mdiKPV_firstMessageDoctor',
    'mdiKPV_complete'
  ]
};
